
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPassengersCard",
  components: {
    Button,
    Skeleton,
  },
  props: ["guid", "order"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const passengers = ref(null);
    const getPassengers = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPassengers?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        passengers.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      passengers,
      getPassengers,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getDateWithDot(date: string): any {
      let parseDate = new Date(date);
      let day = parseDate.getDate();
      let month = parseDate.getMonth();
      let year = parseDate.getFullYear();
      return day + " " + this.month[month] + " " + year;
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getPassengers();
  },
});
